<template>
    <div>
        <loader v-if="isLoading" />
        <table v-else class="table b-table list table-hover table-borderless">
            <thead>
                <tr>
                    <th v-if="invoiceItems.length > 1"></th>
                    <th>Item:</th>
                    <th>Patient:</th>
                    <th>Reason:</th>
                    <th>Note:</th>
                    <th>Date:</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(invoiceItem, i) in invoiceItems" :key="i">
                    <td v-if="invoiceItems.length > 1" class="cursor-move">
                        <!-- TODO : draggable -->
                        <!-- refer : /components/client-notes/note-list.vue -->
                        <!-- TODO : display date after name -->
                        <i class="cus-black-white-swatch" />
                    </td>
                    <td>
                        <!-- TODO : make it clickable, to follow item-list -->
                        <!-- refer : src/components/medical-records/record-row.vue -->
                        <item-name-row
                            v-if="invoiceItem.item"
                            :invoiceItem="invoiceItem"
                            :name="
                                invoiceItem.item.name +
                                ' (' +
                                _carbonDateDisplay(invoiceItem.date) +
                                ')'
                            "
                            @view="viewRecord"
                            @edit="editRecord"
                            :disabled="isHasUsersChooseInvoice"
                        />
                    </td>
                    <td>
                        <patient-name
                            :use-router="USE_PATIENT_MODULE_VUE"
                            :patient="invoiceItem.patient"
                        />
                    </td>
                    <td>
                        <span v-if="invoiceItem.decline_type">
                            {{ invoiceItem.decline_type.value }}</span
                        >
                    </td>
                    <td>
                        {{ invoiceItem.decline_note }}
                    </td>
                    <td>
                        {{ _carbonDateDisplay(invoiceItem.update_at) }}
                    </td>
                    <td>
                        <i
                            v-if="_hasAccess('billing.invoice.item.insert') && 
                            (   invoiceDetails.status == BILLINGS.INVOICE.TYPE_OPEN &&
                                isBusinessActorActive(invoiceDetails.client))"
                            class="cus-page-add cursor-pointer"
                            v-b-tooltip.hover
                            title="Insert Item"
                            @click="insertItem(invoiceItem)"
                            :class="
                                isHasUsersChooseInvoice
                                    ? 'disabled cursor-not-allowed'
                                    : 'cursor-pointer'
                            "
                        ></i>
                        <!-- TODO : TBC need gear icon ? it is always hidden in apps -->
                    </td>
                </tr>
                <tr v-if="invoiceItems.length === 0">
                    <td colspan="7"><i>No records available</i></td>
                </tr>
            </tbody>
        </table>

        <b-pagination
            v-if="meta && meta.lastPage > 1"
            class="vet-pagination"
            align="right"
            v-model="meta.currentPage"
            :total-rows="meta.total"
            :per-page="meta.perPage"
            prev-text="Prev"
            next-text="Next"
            :hide-goto-end-buttons="true"
        />

        <modal-record ref="modalRecord" @onSuccess="onSuccess" />
        <modal-view-record ref="modalViewRecord" />
        <modal-insert-invoice-item
            ref="modal-insert-invoice-item"
            modal-id="modal-insert-invoice-item"
            @reload="onSuccess"
        />
    </div>
</template>

<script>
/**
 * @name DeclinedList
 * @description List of declined items for invoice page
 * @see apps/application/views/staff/billing/invoice/invoice/sub/item/decline_list.php
 * @see apps/assets/js/module/billing/item.js
 * @
 */
import Loader from "@/components/elements/loader-list";
import InvoiceDeclinedService from "@/services/invoice/invoice-declined";
import PatientName from "@/components/commons/patient-name";
import ItemNameRow from "@/components/item/item-name-row";
import BILLINGS from "@/constants/billings";
import invoiceHelper from "@/mixins/invoice";
import { isEmpty } from "lodash";
export default {
    mixins: [invoiceHelper],
    components: {
        Loader,
        PatientName,
        ItemNameRow,
        ModalRecord: () => import("@/module/commons/record/create-update"),
        ModalViewRecord: () => import("@/components/medical-records/view"),
        ModalInsertInvoiceItem: () =>
            import(
                "@/components/invoice-declined/modal-insert-invoice-item.vue"
            )
    },
    data() {
        return {
            isLoading: false,
            invoiceItems: [],
            meta: null,
            BILLINGS
        };
    },
    computed: {
        invoiceDetails() {
            return this.$store.getters["billing/invoiceDetails"];
        },
        invoiceId() {
            let invoice = this.$store.getters["billing/invoiceDetails"];
            return invoice ? invoice.id : null;
        },
        isEditable() {
            return (
                this.row.business &&
                this.row.business.id === this._setting.business_id
            );
        },
        isHasUsersChooseInvoice() {
            return this.invoiceId
                ? !isEmpty(
                      this.$store.getters["billing/findUserChooseInvoice"](
                          this.invoiceId
                      )
                  )
                : false;
        }
    },
    async mounted() {
        this.getList();
    },
    methods: {
        getList(page = 1) {
            let self = this;
            self.invoiceItems = [];
            self.isLoading = true;
            const params = {
                page: page,
                perPage: self.PER_PAGE
            };
            InvoiceDeclinedService.getDeclinedItems(this.invoiceId, params)
                .then(res => {
                    if (res) {
                        self.invoiceItems = res.resources;
                        self.meta = res.meta;
                    } else {
                        throw "Error : Unable to retrieve declined item list";
                    }
                })
                .catch(error => {
                    this._message(
                        "Error : Unable to retrieve declined item list",
                        "danger"
                    );
                    console.error(error);
                })
                .finally(() => {
                    self.isLoading = false;
                });
        },
        isBusinessActorActive(client) {
            return (
                client &&
                client.single_business_actor &&
                client.single_business_actor.isactive
            );
        },
        editRecord(recordDetails) {
            this.$refs.modalRecord.open(recordDetails);
        },
        viewRecord(recordDetails) {
            this.$refs.modalViewRecord.open(recordDetails);
        },
        getPatientOwnerId(record) {
            const { active_owners } = record.patient;
            if (active_owners[0]) {
                return active_owners[0].id;
            } else {
                return null;
            }
        },
        onSuccess() {
            this.getList();
            this.$emit("reload-invoice-details");
        },
        async insertItem(invoiceItem) {
            if (this.isHasUsersChooseInvoice) {
                return;
            }

            let proceed = await this.checkInvoiceStatus(this.invoiceId);
            if (!proceed) {
                this.$emit("reload-invoice-details");
                return;
            }

            let invoice = this.$store.getters["billing/invoiceDetails"];
            let date = invoice.is_editable
                ? this._fromDateCarbon(invoiceItem.date).toFormat("X")
                : this._fromDateCarbon(invoice.start).toFormat("X");

            this.$store.dispatch("checkBillingLock", {
                date,
                onProceed: () =>
                    this.$refs["modal-insert-invoice-item"].open(invoiceItem),
                onError: message => this._message(message, "danger")
            });
        },
        proceed(invoiceItem) {
            this.isLoading = true;
            InvoiceDeclinedService.insertItem({ id: invoiceItem.id })
                .then(res => {
                    if (res.code == 200) {
                        this._message(res.message);
                        this.onSuccess();
                    } else {
                        this._message(res.message, "danger");
                    }
                })
                .catch(error => {
                    this._message("Error : Unable to insert item", "danger");
                    console.error(error);
                })
                .finally(() => {
                    self.isLoading = false;
                });
        }
    }
};
</script>
